module.exports = __webpack_public_path__ + "assets/img/s1.4e04039f.jpg";